import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=13d498ac&scoped=true&"
import script from "./PhoneInput.vue?vue&type=script&lang=ts&"
export * from "./PhoneInput.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=13d498ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d498ac",
  null
  
)

export default component.exports